import {Route, Routes, useNavigate} from "react-router-dom";
import './App.css'
import Login from "./moduls/Login/Login";
import Job from "./moduls/Job/Job";
import Registration from "./moduls/Login/Registration";
import {createContext, useContext, useEffect, useState} from "react";
import {Context} from "./index";
import {observer} from "mobx-react-lite";
import BlockPage from "./moduls/BlockPage/BlockPage";
import socketConn from "./socket"
import {fetchChat, fetchMsg} from "./http/ChatAPI";
import PreloaderNewTask from "./moduls/Preloader/PreloaderNewTask";
import {fetchSetting} from "./http/SettingsAPI";
import {fetchTracking} from "./http/TrackingAPI";

export const FriendContext = createContext()
export const SocketContext = createContext()


function App() {

    const {userStore, settingStore, trackingStore} = useContext(Context)
    const navigate = useNavigate()

    const [friendList, setFriendList] = useState([])
    const [onlineUsers, setOnlineUsers] = useState([])
    const [notification, setNotification] = useState([])
    const [messages, setMessages] = useState([])
    const [closeTask, setCloseTask] = useState([])
    const [oneFriend, setOneFriend] = useState({})
    const [oneChatId, setOneChatId] = useState({})
    const [oneTask, setOneTask] = useState({})
    const [socket, setSocket] = useState(() => socketConn(userStore.token))


    useEffect(() => {
        if (localStorage.getItem('token')) {
            userStore.checkAuth()
        }
        if (userStore.isAuth) {
            navigate('/job/task')
        }
        if (userStore.user.block) {
            userStore.logout()
            navigate('/blocked')
        }
        setSocket(() => socketConn(userStore.token))
        fetchChat().then(data => setFriendList(data))
        fetchMsg().then(data => setMessages(data))
        fetchSetting().then(data => settingStore.setSetting(data))
        fetchTracking().then(data => trackingStore.setTrackings(data))
    }, [userStore.isAuth, userStore.token])

    if (userStore.isLoading) {
        return <PreloaderNewTask/>
    }

    return (
        <FriendContext.Provider
            value={{
                friendList,
                setFriendList,
                messages,
                setMessages,
                oneFriend,
                setOneFriend,
                oneChatId,
                setOneChatId,
                onlineUsers,
                setOnlineUsers,
                notification,
                setNotification,
                closeTask,
                setCloseTask,
                oneTask,
                setOneTask
            }}
        >
            <SocketContext.Provider value={{socket}}>
                <div className="app">
                    <Routes>
                        <Route path="/" element={<Login/>}/>
                        <Route path="/login" element={<Login/>}/>
                        <Route path="/registration" element={<Registration/>}/>
                        <Route path="/blocked" element={<BlockPage/>}/>
                        <Route path="/job/*" element={<Job/>}/>
                    </Routes>
                </div>
            </SocketContext.Provider>
        </FriendContext.Provider>
    );
}

export default observer(App);
